<template>
  <div id="sky" :style="{ background: skyGradient }"></div>
</template>

<script>
export default {
  data: () => ({
    skyGradient: '',
    skyTimer: null,
  }),
  mounted() {
    this.updateSky();

    const now = new Date();
    const delayToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    setTimeout(() => {
      this.updateSky();
      this.skyTimer = setInterval(this.updateSky, 60000); // every minute
    }, delayToNextMinute);
  },
  beforeDestroy() {
    clearInterval(this.skyTimer);
  },
  methods: {
    updateSky() {
      const hour = new Date().getHours();

      /* divided game time into four session with each 4 hours */
      if (hour >= 7 && hour < 11) {
        // Dawn
        this.skyGradient = 'linear-gradient(to bottom, #FFD580, #FFF5E1)';
      } else if (hour >= 11 && hour < 15) {
        // Daytime
        this.skyGradient = 'linear-gradient(to bottom, #00aaff 0%, #aeefff 70%, #ffffff 100%)';
      } else if (hour >= 15 && hour < 19) {
        // Sunset
        this.skyGradient = 'linear-gradient(to bottom, #FF8C42, #FFDDC1)';
      } else {
        // Night
        this.skyGradient = 'linear-gradient(to bottom, #001f3f, #003366)';
      }
    },
  },
};
</script>

<style scoped>
#sky {
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  z-index: 0;
  transition: background 1s ease-in-out;
}
</style>
